{
  "analytics": {
    "title": "Analyse",
    "mobileTitle": "Analyse",
    "landing": {
      "title": "Analyse-Übersicht",
      "description": "Erkunden Sie Einblicke und Berichte über Ihre Filialleistung",
      "taskStatistics": {
        "title": "Aufgabenanalyse",
        "description": "Aufgabentrends und Abschlussraten im Zeitverlauf anzeigen"
      },
      "productGaps": {
        "title": "Produktlücken",
        "description": "Out-of-Stock-Produkte und Marken analysieren"
      },
      "shelfScanReport": {
        "title": "Regal-Scan-Bericht",
        "description": "Anomalien bei der Regalerkennung identifizieren"
      }
    },
    "taskStatistics": {
      "title": "Aufgabenstatistik",
      "description": "Überblick über Aufgabentrends im Zeitverlauf"
    },
    "productGaps": {
      "title": "Produktlücken",
      "description": "Top 10 Out-of-Stock-Produkte und Marken",
      "viewMode": "Ansicht",
      "topProducts": "Top 10 Produkte",
      "topBrands": "Top 10 Marken",
      "outOfStockCount": "Out-of-Stock-Anzahl",
      "noData": "Keine Out-of-Stock-Daten für den ausgewählten Zeitraum verfügbar",
      "productDetails": "Produktdetails",
      "brandDetails": "Markendetails",
      "name": "Name",
      "brand": "Marke",
      "gtin": "GTIN",
      "storeBreakdown": {
        "title": "Filialübersicht",
        "description": "Out-of-Stock-Vorkommen pro Filiale, sortiert nach aktuellem Wert",
        "storeName": "Filiale",
        "latestCount": "Aktuell",
        "totalCount": "Gesamt",
        "trend": "Trend",
        "noData": "Keine Filialdaten verfügbar"
      }
    },
    "chart": {
      "taskCount": "Aufgabenanzahl",
      "refillTasks": "Auffüllaufgaben",
      "checkTasks": "Prüfaufgaben",
      "checkedTasks": "Erledigte Prüfaufgaben",
      "weekend": "Wochenende"
    },
    "error": {
      "title": "Fehler beim Laden der Analyse",
      "description": "Die Analysedaten konnten nicht geladen werden. Bitte versuchen Sie es später erneut."
    },
    "noData": {
      "title": "Keine Analysedaten",
      "description": "Für diese Filiale sind noch keine Analysedaten verfügbar."
    },
    "dateRange": {
      "label": "Zeitraum auswählen"
    },
    "storeSelect": {
      "placeholder": "Filialen auswählen",
      "noneSelected": "Keine Filialen ausgewählt",
      "allSelected": "Alle Filialen",
      "selectedCount": "{{count}} Filialen ausgewählt",
      "all": "Alle",
      "none": "Keine",
      "selectStores": "Wählen Sie mindestens eine Filiale aus, um Analysen anzuzeigen"
    },
    "storeBreakdown": {
      "title": "Filialdetails für {{date}}",
      "storeName": "Filiale"
    },
    "shelfScanReport": {
      "title": "Regal-Scan-Bericht",
      "description": "Scan-Anomalien durch Vergleich der erkannten Regalanzahl identifizieren",
      "noData": "Keine Regal-Scan-Daten für den ausgewählten Zeitraum verfügbar",
      "legend": {
        "ok": "OK",
        "warningLight": "Abweichung (<10%)",
        "warning": "Anomalie (≥10%)",
        "noData": "Kein Scan",
        "weekend": "Wochenende"
      },
      "tooltip": {
        "date": "Datum",
        "detected": "Erkannt",
        "expected": "Erwartet",
        "previousDay": "Vorheriger Scan",
        "shelves": "Regale",
        "ok": "Scan OK",
        "warningLight": "Geringe Abweichung (<10%)",
        "warning": "Signifikante Anomalie (≥10%)",
        "viewScan": "Scan anzeigen",
        "doubleClickHint": "Doppelklick zum Öffnen des Scans"
      },
      "table": {
        "storeName": "Filiale",
        "deployDbScanDate": "DeployDB Scan-Datum",
        "expected": "Erwartet",
        "latest": "Aktuell",
        "anomalies": "Anomalien",
        "trend": "Trend",
        "notAvailable": "N/A"
      }
    }
  },
  "productFinder": {
    "title": "Markt",
    "mobileTitle": "Markt",
    "placeholder": "Produkt oder GTIN suchen",
    "searchModeTerm": "Name",
    "searchModeGTIN": "GTIN",
    "noResults": {
      "title": "Keine Produkte gefunden.",
      "subtitleGtin": "Für die GTIN {{term}} konnte kein Produkt gefunden werden.",
      "subtitleSearchTerm": "Es wurde leider kein passendes Produkt zu für den Suchbegriff {{term}} gefunden."
    },
    "barcodeScanner": {
      "openButton": "GTIN scannen",
      "header": "Scanne eine GTIN",
      "opening": "Starte Kamera ...",
      "errorOpeningCamera": "Fehler beim Öffnen der Kamera. Bitte überprüfen Sie Ihre Berechtigungen.",
      "scanHint": {
        "default": "Barcode hier ausrichten",
        "unknownGtin": "Unbekannte GTIN. Bitte versuchen Sie es erneut.",
        "invalidGtin": "Ungültige GTIN. Bitte versuchen Sie es erneut.",
        "error": "Barcode konnte nicht gelesen werden. Bitte versuchen Sie es erneut."
      }
    },
    "errors": {
      "invalidGTIN": "Ungültige GTIN"
    }
  },
  "storeMap": {
    "title": "Filialkarte",
    "reset": "Zurücksetzen",
    "shelfSearchPlaceholder": "Wähle ein Regal aus",
    "controls": {
      "zoomIn": "Vergrößern",
      "zoomOut": "Verkleinern",
      "reset": "Zoom zurücksetzen"
    },
    "changeMapOrigin": {
      "DEPLOY_DB": "Zur Scan-Karte wechseln",
      "SCAN": "Zur DeployDB-Karte wechseln",
      "UNAVAILABLE": "Keine DeployDB-Karte für diese Filiale",
      "SINGLE_SCAN": "Ein einzelner Scan zeigt immer seine eigene Karte"
    },
    "scanMode": {
      "enter": "Nur den letzten Scan zeigen",
      "exit": "Zurück zum ganzen Tag",
      "line": "Scan {{time}} · Route {{route}}",
      "older": "Früherer Scan",
      "newer": "Späterer Scan"
    },
    "shelf": {
      "title": "Regal {{name}}",
      "schematic": "Schematische Ansicht",
      "image": "Bildansicht",
      "product": "Produktansicht",
      "productLegacy": "Produktansicht (alt)",
      "expandBtn": "Regalansicht vergrößern",
      "collapseBtn": "Regalansicht verkleinern",
      "navigateToLeftNeighbour": "Zum linken Regal navigieren",
      "navigateToRightNeighbour": "Zum rechten Regal navigieren",
      "noInformationAvailable": "Zu den Produkten in diesem Regal sind keine Informationen verfügbar.",
      "lastWithProducts": "Zuletzt mit Produkten: {{date}}",
      "noProductsYet": "Bisher keine Produkte erfasst",
      "source": {
        "line": "Datenaktualität: {{age}} ({{time}})",
        "sameDay": "gewählter Tag",
        "oneDayBefore": "1 Tag vor dem gewählten Tag",
        "daysBefore": "{{days}} Tage vor dem gewählten Tag",
        "notCurrent": "Zu alt für Aussagen zu Lücken und Preisen."
      },
      "unknownFacingHint": "Diesem Fach konnte kein Produkt zugeordnet werden.",
      "priceLabel": {
        "gtin": "Preisschild · GTIN {{gtin}}",
        "noGtin": "Preisschild · keine GTIN gelesen"
      },
      "facingState": {
        "noImage": "Erkannt, kein Bild",
        "noGtin": "Nicht erkannt"
      },
      "errors": {
        "notFound": {
          "title": "Regal nicht gefunden",
          "description": "Dieses Regal scheint nicht zu existieren."
        }
      }
    },
    "shelfSearch": {
      "tooltip": "Suche nach einem Regal",
      "placeholder": "Wähle ein Regal",
      "noIds": "Keine Regal-IDs verfügbar",
      "noMatch": "Kein passendes Regal gefunden"
    },
    "layers": {
      "tooltip": "Kartendarstellung anpassen",
      "headingMapType": "Kartentyp",
      "headingExtraInfo": "Zusätzliche Informationen anzeigen",
      "mapType": {
        "2d": "2D",
        "3d": "3D",
        "360": "360°"
      },
      "extra": {
        "oos": "OOS",
        "unknown": "Unbekannt",
        "categories": "Kategorien",
        "categoriesDebug": "Kategorien (Debug)",
        "dataAge": "Aktualität"
      },
      "legendUnknownShare": "Anteil der Regalfächer mit <strong>UNKNOWN</strong> Stock-Levels",
      "legendDataAge": {
        "title": "Alter der Daten",
        "sameDay": "Gewählter Tag",
        "upTo3Days": "1–3 Tage davor",
        "upTo7Days": "4–7 Tage davor",
        "older": "8 Tage oder mehr davor",
        "noData": "Keine aktuellen Daten"
      }
    },
    "infoPopover": {
      "shelf": "Regal",
      "category": "Kategorie",
      "shareUnknown": "Anteil unbekannter Produkte",
      "noFacings": "Keine Facings verfügbar"
    }
  },
  "todoList": {
    "title": "Aufgaben",
    "mobileTitle": "Aufgaben",
    "task": "Aufgabe",
    "tabs": {
      "OPEN": "Offene Aufgaben",
      "COMPLETED": "Abgeschlossene Aufgaben"
    },
    "no-result": {
      "title": "No Result",
      "no-tasks": "No tasks available.",
      "no-completed-tasks": "Keine abgeschlossenen Aufgaben.",
      "no-tasks-filtered": "No tasks available for filter: {{type}}"
    },
    "badges": {
      "ALL": "Alle",
      "REFILL": "Auffüllen",
      "REFILLED": "Aufgefüllt",
      "CHECK": "Prüfen",
      "CHECKED": "Geprüft",
      "NEW": "Neu",
      "REORDER": "Nachbestellen",
      "REORDERED": "Nachbestellt",
      "nInStock": "{{n}} auf Lager"
    },
    "tasks-description": {
      "OPEN": {
        "CHECK": "Bestand oder Produkt muss geprüft werden",
        "REFILL": "Regallücke muss aufgefüllt werden",
        "REORDER": "Produkt muss nachbestellt werden"
      },
      "COMPLETED": {
        "CHECK": "Bestand oder Produkt bereits geprüft",
        "REFILL": "Regallücke bereits aufgefüllt",
        "REORDER": "Produkt bereits nachbestellt"
      }
    },
    "drawerTitle": "{{count}} Entdeckte Produkte",
    "filterAndSort": {
      "title": "Sortierung und Filter",
      "sortBy": "Sortieren nach",
      "filter": "Filtern",
      "sortOptions": {
        "newestFirst": "Neueste zuerst",
        "oldestFirst": "Älteste zuerst",
        "advertisementsFirst": "Werbeprodukte zuerst",
        "alphabetical": "Alphabetisch A-Z",
        "shelf": "Regal"
      },
      "options": {
        "all": {
          "title": "Alle",
          "description": "Keine Sekundärfilterung vornehmen."
        },
        "newTasks": {
          "title": "Nur neue Aufgaben anzeigen",
          "description": "Es werden nur Aufgaben angezeigt, die vom letzten Scan neu erkannt wurden."
        },
        "promotionalProducts": {
          "title": "Nur Werbeprodukte anzeigen",
          "description": "Es werden nur aktuelle Werbeprodukte angezeigt."
        },
        "manualReorders": {
          "title": "Nur manuelle Nachbestellungen anzeigen",
          "description": "Es werden nur Nachbestellungen angezeigt, die manuell getätigt werden müssen."
        }
      }
    },
    "emptyStates": {
      "noTasksToday": "Keine Aufgaben für heute.",
      "noCompletedToday": "Du hast heute noch keine Aufgaben erledigt.",
      "allTasksDoneToday": "Du hast alle Aufgaben für heute erledigt!",
      "allTasksDoneInStore": "Du hast alle Aufgaben in \"{{category}}\" heute erledigt!"
    },
    "toasts": {
      "completedError": {
        "title": "Fehler beim Abschließen",
        "description": "Beim Abschließen der Aufgabe ist ein Fehler aufgetreten. Bitte versuche es erneut."
      },
      "reopenError": {
        "title": "Fehler beim Wiedereröffnen",
        "description": "Beim Wiedereröffnen der Aufgabe ist ein Fehler aufgetreten. Bitte versuche es erneut."
      }
    },
    "undo": "Rückgängig"
  },
  "panorama": {
    "title": "Panorama",
    "hint": "Klicken Sie auf einen blauen Kreis, um die Panorama-Ansicht zu starten"
  },
  "storeSelection": {
    "noStores": {
      "title": "Keine Filiale verfügbar.",
      "subtitle": "Sie sind möglicherweise keiner Filiale zugeordnet oder es wurde noch kein Scan durchgeführt."
    },
    "selectStore": {
      "title": "Wählen Sie eine Filiale aus",
      "searchPlaceholder": "Suche nach einer Filiale",
      "noStoresFound": "Kein Filiale gefunden.",
      "noAddress": "Keine Adresse verfügbar"
    },
    "noStoreAccess": {
      "title": "Sie haben keinen Zugriff auf diese Filiale oder sie existiert nicht.",
      "subtitle": "Bitte wählen Sie eine gültige Filiale aus der Liste aus.",
      "back": "Zur Filialauswahl zurückkehren"
    }
  },
  "scanSelection": {
    "noScans": {
      "title": "Keine Scans verfügbar.",
      "subtitle": "Für diese Filiale wurden noch keine Scans durchgeführt.",
      "back": "Zurück zur Filialauswahl"
    },
    "selectScan": {
      "title": "Wählen Sie einen Scan aus, um fortzufahren",
      "noScansFound": "Keine Scans gefunden."
    },
    "noScansAvailable": {
      "title": "Keine Scans verfügbar.",
      "subtitle": "Für diese Filiale sind noch keine Scans verfügbar.",
      "back": "Zurück zur Filialauswahl"
    },
    "scanDoesNotExist": {
      "title": "Dieser Scan existiert nicht.",
      "subtitle": "Der gesuchte Scan konnte nicht gefunden werden.",
      "back": "Zum aktuellsten Scan zurückkehren"
    },
    "latestKeyword": "Letzter"
  },
  "account": {
    "title": "Profil",
    "mobileTitle": "Profil",
    "systemSettings": "Systemeinstellungen",
    "language": {
      "title": "Sprache auswählen",
      "label": "Sprache",
      "options": {
        "en": "Englisch",
        "de": "Deutsch"
      }
    },
    "storeAssignments": {
      "label": "Zugeordnete Filialen",
      "noAddressAvailable": "Keine Adresse verfügbar",
      "noAssignmentsHint": "Sie sind derzeit keiner Filiale zugeordnet."
    },
    "store": {
      "title": "Filiale auswählen",
      "label": "Filiale"
    },
    "scan": {
      "title": "Scan auswählen",
      "label": "Scan"
    },
    "version": {
      "label": "App-Version"
    },
    "licenses": {
      "label": "Lizenzen",
      "dictionary": "Die Zerlegung zusammengesetzter Wörter in der Produktsuche nutzt das deutsche Wörterbuch von jWordSplitter von Daniel Naber (basierend auf Morphy, mit Ergänzungen von LanguageTool), lizenziert unter",
      "source": "Quelle"
    },
    "logout": "Abmelden"
  },
  "signIn": {
    "title": "Melde dich bei Ubica an",
    "description": "Wir haben mehrere Anmeldeoptionen für Ihr Team gefunden. Wählen Sie bitte unter eine Anmeldenoption aus, um fortzufahren.",
    "optionText": "ODER",
    "action": "Anmelden mit"
  },
  "common": {
    "greeting": "Hallo {{name}}!",
    "store": "Filiale",
    "role": "Rolle",
    "statusLegend": "Status",
    "inStock": "Auf Lager",
    "outOfStock": "Out of Shelf",
    "unknownStock": "Unbekannt",
    "all": "Alle",
    "loading": "Lädt...",
    "close": "Schließen",
    "back": "Zurück",
    "select": "Auswählen",
    "next": "Weiter",
    "noAddress": "Keine Adresse verfügbar",
    "paginationInfo": "{{currentCount}} von {{totalCount}} Ergebnisse",
    "resultInfo": "{{count}} Ergebnisse",
    "loadingStoreData": "Lade Ihre Filialdaten...",
    "loadingSignInClients": "Lade Anmeldeoptionen...",
    "save": "Speichern",
    "unexpectedError": {
      "title": "Unerwarteter Fehler",
      "description": "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut."
    },
    "dialog": {
      "confirm": {
        "title": "Aktion bestätigen",
        "action": "Bestätigen"
      },
      "cancel": "Abbrechen"
    },
    "datepicker": {
      "placeholder": "Datum auswählen",
      "today": "Heute",
      "yesterday": "Gestern",
      "nextMonth": "Nächster Monat",
      "previousMonth": "Vorheriger Monat"
    },
    "toast": {
      "close": "Benachrichtigung schließen",
      "dismiss": "Verwerfen"
    },
    "stock": "Bestand",
    "roles": {
      "system": {
        "ADMIN": "Administrator",
        "USER": "Benutzer",
        "DEVELOPER": "Entwickler",
        "VIEWER": "Betrachter",
        "CONTRIBUTOR": "Mitwirkender"
      },
      "store": {
        "STORE_MANAGER": "Filialmanager",
        "STORE_EMPLOYEE": "Filialmitarbeiter",
        "STORE_VIEWER": "Filialbetrachter"
      }
    },
    "error": {
      "serverError": {
        "message": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
        "action": "Seite neu laden"
      }
    },
    "productBarcodeView": {
      "title": "Barcode scannen",
      "description": "Scannen Sie diesen Barcode ein, um das Produkt in einem anderen System zu finden.",
      "copyLabel": "GTIN kopieren"
    },
    "filepicker": {
      "prompt": "Datei auswählen oder hineinziehen",
      "unsupported": "Datei wird nicht unterstützt"
    },
    "accessDenied": {
      "title": "Zugriff verweigert",
      "description": "Sie haben nicht die Berechtigungen, um auf diese Seite zuzugreifen. Wenn Sie glauben, dass dies ein Fehler ist, kontaktieren Sie bitte einen Administrator.",
      "action": "Zurück"
    },
    "newVersion": {
      "title": "Neue Version verfügbar",
      "description": "Bitte aktualisieren Sie, um unerwartete Probleme zu vermeiden.",
      "action": "Jetzt aktualisieren"
    }
  },
  "shelfCategories": {
    "DIAPERS": "Windeln",
    "CLEANING": "Reinigungsprodukte",
    "HEALTH": "Gesundheit & Medizin",
    "PET": "Tierbedarf",
    "BABY_FOOD": "Babynahrung",
    "HAIR": "Haarpflege",
    "PARFUM": "Parfum & Düfte",
    "TOOTH_BRUSH": "Zahnpflege",
    "TOILET_PAPER": "Toilettenpapier",
    "FOOD": "Lebensmittel",
    "DEO": "Deodorant",
    "SHOWER_GEL": "Duschgel & Körperpflege",
    "BEVERAGES": "Getränke",
    "COFFEE": "Kaffee",
    "EGGS": "Eier",
    "PASTA": "Nudeln",
    "SWEETS": "Süßigkeiten",
    "BONBONS": "Bonbons",
    "HOUSEKEEPING": "Haushalt"
  },
  "quickSelects": {
    "store": {
      "name": "Filial-Schnellauswahl",
      "noAddress": "Keine Adresse verfügbar",
      "redirectedToLatestScan": {
        "title": "Zum aktuellsten Scan von Filiale {{storeName}} weitergeleitet",
        "description": "Kein Scan am {{scanDate}} für Filiale {{storeName}}. Sie wurden zum aktuellsten Scan weitergeleitet."
      },
      "errorSwitchingStore": {
        "title": "Fehler beim Wechseln der Filiale",
        "description": "Die Filiale konnte nicht gewechselt werden. Bitte versuchen Sie es erneut."
      }
    },
    "scan": {
      "name": "Scan-Schnellauswahl",
      "latestPreset": "Letzter Scan",
      "previousScanPreset": "Vorheriger Scan",
      "nextScanPreset": "Nächster Scan"
    },
    "day": {
      "name": "Tages-Schnellauswahl",
      "latestPreset": "Letzter Tag",
      "previousPreset": "Vorheriger Tag",
      "nextPreset": "Nächster Tag",
      "lastScan": "Letzter Scan: {{time}}"
    }
  },
  "storeManagement": {
    "title": "Filialverwaltung",
    "inventoryUpload": "Bestandsdaten-Upload",
    "date": "Datum",
    "upload": "Upload",
    "uploading": "Uploading...",
    "clickHere": "Datei-Auswahl",
    "uploadSuccess": "Datei erfolgreich hochgeladen!"
  },
  "admin": {
    "title": "Administration",
    "goBack": "Zurück zur App",
    "userManagement": {
      "title": "Benutzerverwaltung",
      "subtitle": "Verwalten Sie Benutzerrollen und Filienzuweisungen unten.",
      "table": {
        "name": "Name",
        "email": "E-Mail-Adresse",
        "role": "Rolle",
        "assignments": "Zuweisungen",
        "searchPlaceholder": "Benutzer suchen",
        "loadingUsers": "Lade Benutzer ...",
        "noUsersMatch": "Keine Benutzer entsprechen der aktuellen Suche.",
        "noStoreAssignments": "Keine Filienzuweisungen",
        "addAssignment": "Filienzuweisung hinzufügen",
        "removeAssignment": "{{storeName}} Zuweisung entfernen",
        "teamMembers": "Teammitglieder",
        "usersCount": "{{count}} Benutzer",
        "adminImplicitAccessHint": "Administratoren haben automatisch Zugriff auf alle Filialen."
      },
      "pagination": {
        "showing": "Zeige {{current}} von {{total}} Benutzern",
        "loadMore": "Mehr laden"
      },
      "dialog": {
        "addGrant": {
          "title": "Filiale {{userName}} zuweisen",
          "description": "Wählen Sie eine Filiale und Rolle für diesen Benutzer aus.",
          "storeLabel": "Filiale",
          "storePlaceholder": "Name der Filiale, Stadt, ...",
          "storeLoading": "Lade Filialen…",
          "roleLabel": "Rolle",
          "cancel": "Abbrechen",
          "assign": "Zuweisen",
          "selectStoreHeading": "Filiale auswählen",
          "selectRoleHeading": "Rolle auswählen",
          "storeNameColumn": "Filialname",
          "addressColumn": "Adresse",
          "loadingStores": "Lade Filialen...",
          "noStoresFoundWithSearch": "Keine Filialen entsprechen Ihrer Suche",
          "allStoresAssigned": "Der Benutzer ist bereits allen verfügbaren Filialen zugewiesen",
          "successTitle": "Zuweisung erfolgreich",
          "successDescription": "{{userName}} wurde der Filiale {{storeName}} zugewiesen"
        },
        "confirmRemove": {
          "title": "Zuweisung von {{userName}} entfernen",
          "message": "Sind Sie sicher, dass Sie die Zuweisung von {{userName}} für Filiale {{storeName}} entfernen möchten?",
          "confirm": "Entfernen",
          "successTitle": "Zuweisung erfolgreich entfernt",
          "errorTitle": "Fehler beim Entfernen der Zuweisung"
        }
      }
    },
    "noAccess": {
      "title": "Administrationszugriff eingeschränkt",
      "description": "Sie verfügen nicht über die erforderlichen Administratorrechte, um diese Seite anzuzeigen. Wenn Sie glauben, dass dies ein Fehler ist, kontaktieren Sie bitte einen Administrator.",
      "action": "Zur Filialauswahl"
    }
  }
}
